<template>
  <div class="row">
    <div class="col-12">
      <Tags />
      <Notes />
      <a class="logout" v-on:click.prevent="logout" href="#">Logout</a>
    </div>
  </div>
</template>

<script>
import Notes from './Notes'
import Tags from './Tags'

export default {
  name: 'Dashboard',
  components: { Notes, Tags },
  mounted () {
    if (!this.logged) {
      this.$router.push({ path: '/sign_in' })
    }
  },
  computed: {
    logged () {
      return this.$cookies.isKey('api_token')
    }
  },
  methods: {
    logout () {
      this.$cookies.remove('api_token')
      this.$router.go({ path: '/' })
    }
  }
}
</script>

<style>
  .logout {
    color: white;
  }
  body { background-color: #323273; }
  h1   { color: #FFF; }
  h2   { color: #FFF; }
  h3   { color: #77A; }
  h5   { color: #BBF; }

  label { color: #FFF; }

  .fixed-font {
    font-family: Courier;
  }

  .page-header {
    margin-left: 8px;
    margin-right: 8px;
  }
  .product-grid {
    margin-left: 8px;
  }
  .product-list {

  }
  .top-padding {
    padding-top: 62px;
  }
  .image-caption {
    width: 100%;
  }
  .image-caption h5 {
    margin-top: 8px;
    color: #56568a;
  }
  .image-caption__wrapper {
    border: 1px solid #CCC;
    margin: 10px 0px 20px 0px;
    padding: 4px;
    background-color: #FFF;
  }
  .image-caption__title {
  }
  button {
    background-color: buttonface;
  }
  @media (max-width: 1020px) {
  }
  @media (max-width: 1020px) and (min-width: 850px) {
  }
  @media (min-width: 700px) and (max-width: 850px) {
  }
  @media (min-width: 600px) and (max-width: 700px) {
  }
  @media (min-width: 500px) and (max-width: 600px) {
  }
  @media (max-width: 500px) {
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue